import React from 'react';
import { ApplicationListLayoutTemplate } from 'themes/layouts';

function ApplicationListLayout(props) {
    return <ApplicationListLayoutTemplate {...props} />;
}

export default ApplicationListLayout;
